// extracted by mini-css-extract-plugin
export default {"wrapper":"Landing_wrapper__8ZlvL","cirlce":"Landing_cirlce__1x20E"};